module.exports = __webpack_public_path__ + "static/img/rank_4.439f3c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_4.png
// module id = 3S/q
// module chunks = 0